<template>
  <div class="entrega-order-share-wrapper">
    <div class="header-box">
      <PageMbHeader 
        :title="entregaTitle"
        :transShow="false" 
        :transOpen="false"
        :iconShow="false"
      />
    </div>
    <div class="order-container">
      <!-- 接口异常 & 状态兜底 -->
      <template v-if="errno == -1 || pageStatus === ORDER_STATE_MAP.error">
        <EmptyState
          emptyType="noNetworkEntrega" 
          @tryAgain="_initData" 
        />
      </template>
      <!-- 订单完成态：完成、取消 -->
      <template 
        v-if="pageStatus === ORDER_STATE_MAP.complete || pageStatus === ORDER_STATE_MAP.cancel"
      >
        <PageState :status="pageStatus">
          <div class="complete_style" v-if="pageStatus === ORDER_STATE_MAP.complete">
            <ServerCard
              :orderId="orderId"
              :data="riderInfo"
            />
          </div>
        </PageState>
      </template>
      <!-- 订单进行态 -->
      <template v-if="pageStatus === ORDER_STATE_MAP.going">
        <div class="order-map">
          <Map
            :mapData="orderData.mapData"
            :orderData="orderData"
            :isH5="true"
            :orderStatus="orderData.status"
            :serverApiTime="serverApiTime"
            @initData="_initData"
          />
        </div>
        <div class="order-card__deatil">
          <Cards
            :orderId="orderId"
          />            
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { isEmpty } from 'lodash-es';
import { ORDER_STATE_MAP } from '@/const/entrega';

import PageMbHeader from '@/components/PageMbHeader';
import EmptyState from '@/components/EmptyState';
import PageState from '@/components/EntregaShare/pageState';
import Map from './map.vue';
import Cards from '@/components/OrderDetailShareCard/index.vue';
import ServerCard from '@/components/OrderDetailShareCard/serverCard.vue'

export default {
  name: 'OrderShare',
  components: {
    Map,
    Cards,
    PageMbHeader,
    EmptyState,
    PageState,
    ServerCard,
  },
  data() {
    return {
      orderId: '',
      pageStatus: '', // 页面状态
      ORDER_STATE_MAP,
      requestTime: 30000, // 10秒轮训一次
      timerName: null,
    }
  },
  computed: {
    ...mapState({
      country: ({ common }) => common.country,
      errno: ({ entrega }) => entrega.errno,
      orderData: ({ entrega }) => entrega.orderData,
      riderInfo: ({ entrega }) => entrega.riderInfo,
      serverApiTime: ({ entrega }) => entrega.serverApiTime,
      orderStatus: ({ entrega }) => entrega.orderStatus,
    }),
    entregaTitle() {
      return this.country === 'BR' ? this.$t('Entrega_name_99_Flash_maAd') : this.$t('FoodC_presentation_DiDi_Delivery_vrwd');
    },
    sailing_c_e_landing_order_common_sw() {
      return {
        eventId: 'sailing_c_e_landing_order_common_sw',
        eventLabel: 'H5订单跟踪页曝光',
        attrs: {
          order_id: this.orderId,
          order_status: this.orderStatus
        },
      };
    },
  },
  created() {
    // 目前先在这里简单处理 闪送 title 问题
    document.title = this.entregaTitle;
  },
  async mounted() {
    const { orderId } = this.$route.query;

    if (!orderId) {
      this.pageStatus = ORDER_STATE_MAP.error;
      return;
    }
    
    this.orderId = orderId;
    await this._initData();
    this.$nextTick(() => {
      if (this.errno === 0) {
        this.loopOrderData();
      }
    })
    this.$trackEvent(this.sailing_c_e_landing_order_common_sw);
  },

  methods: {
    ...mapActions('entrega', ['getOrderDetailInfo']),
    async _initData() {
      const res = await this.getOrderDetailInfo({ orderId: this.orderId });
      if (isEmpty(res)) {
        this.pageStatus = ORDER_STATE_MAP.error;
        return;
      }
      const { pageStatus = -1 } = res;
      // 订单状态变更
      this.pageStatus = pageStatus;
    },
    //数据轮训
    loopOrderData() {
      this.timerName = setInterval(async () => {
        await this._initData();
        if (this.pageStatus === ORDER_STATE_MAP.going) {
          this.clearIntervalFn();
        }
      }, this.requestTime);
    },
    clearIntervalFn() {
      clearInterval(this.timerName);
      this.timerName = null;
    },
  },
  beforeDestroy() {
    this.clearIntervalFn();
  },
}
</script>

<style lang="scss" scoped>
.header-box {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 100;
  height: rem(94);
}
.order-container {
  display: flex;
  width: auto;
  display: block;
  height: auto;
}
.order-map {
  flex: 1;
  height: rem(914);
}
.order-box {
  height: auto;
}
.order-card__deatil {
  width: auto;
  max-height: none;
  height: auto;
  overflow: auto;
}
.complete_style {
  margin: 0 rem(24);
}
</style>

